import { render, staticRenderFns } from "./SpeakersEdit.vue?vue&type=template&id=0998115d&"
import script from "./SpeakersEdit.vue?vue&type=script&lang=js&"
export * from "./SpeakersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports